<!-- FloatingTabButton.vue -->
<template>
    <div
      class="floating-tab"
      :style="buttonStyle"
      @click="toggleSidebar"
    >
      <b-button class="tab-button" size="md">
        <i class="fas fa-folder"></i> <md-icon icon="rocket"></md-icon>
      </b-button>
    </div>
  </template>
  
  <script>
import { mapState, mapActions } from 'vuex';
  export default {
    name: 'FloatingTabButton',
    data() {
      return {
        scrollPosition: 0,
        isVisible: true,
        timeout: null, // To store the timeout ID
      };
    },
    computed: {
        ...mapState("highlights", ["isSidebarOpen","selectedModule"]),
        buttonStyle() {
            return {
            opacity: this.isVisible ? 1 : 0,
            transition: 'opacity 0.3s, transform 0.3s',
            transform: this.isVisible ? 'scale(1)' : 'scale(0.8)',
            };
        },
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
      clearTimeout(this.timeout); // Clear timeout on component destroy
    },
    methods: {
        ...mapActions('highlights', ["toggleSidebar","selectModule"]),
        handleScroll() {
            const currentScrollPosition = window.scrollY;
            this.isVisible = false;
    
            // Update the scroll position
            this.scrollPosition = currentScrollPosition;
    
            // Clear the previous timeout
            clearTimeout(this.timeout);
    
            // Set a new timeout to hide the button if no scrolling occurs
            this.timeout = setTimeout(() => {
            this.isVisible = true; // Show the button after stopping scrolling
            }, 300); // Adjust this duration as needed (in milliseconds)
        },
    },
  };
  </script>
  
  <style scoped>
  .floating-tab {
    position: fixed; /* Fix the position */
    top: 5rem; /* Adjust the vertical position */
    left: -8px; /* Adjust the horizontal position */
    z-index: 1000; /* Ensure it appears above other content */
  }
  
  .tab-button {
    background-color: #8a2be28c;
    color: whitesmoke;
    border-radius: 0.25rem; /* Slightly rounded corners */
    padding: 5px 15px; /* Padding around the button */
  }

  .tab-button:hover {
    background-color: #6a1b9a; 
    transform: translateY(-2px); 
    padding: 5px 20px; 
  }
  </style>
  